import { ReactNode, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import { useFlexSalesForm, useFlexSalesFormState } from './FlexSalesForm';
import { LoadingButton } from '../buttons';
import { erroHttpErrorSelector, erroValidationErrorsSelector } from '../../state';

export const ActionsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  marginTop: theme.spacing(2),
  justifyContent: 'space-around',
}));

interface ActionsProps {
  onCancel: () => void;
  submitLabel: ReactNode;
  cancelLabel: ReactNode;
  loading?: boolean;
}

const FlexSalesFormActions = ({
  onCancel,
  cancelLabel,
  submitLabel,
  loading = false,
}: ActionsProps) => {
  const { reset } = useFlexSalesForm();
  const { isSubmitting, isValid } = useFlexSalesFormState();
  const httpError = useSelector(erroHttpErrorSelector);
  const validationErrors = useSelector(erroValidationErrorsSelector);
  useEffect(() => {
    if (httpError || (validationErrors && validationErrors.length > 0)) {
      reset(undefined, { keepValues: true });
    }
  }, [httpError, validationErrors]);
  return (
    <ActionsContainer>
      <Button disabled={isSubmitting} variant="contained" onClick={onCancel}>
        {cancelLabel}
      </Button>
      <LoadingButton
        type="submit"
        loading={isSubmitting || loading}
        disabled={!isValid}
        variant="contained"
      >
        {submitLabel}
      </LoadingButton>
    </ActionsContainer>
  );
};

export default FlexSalesFormActions;
